export default __webpack_public_path__ + "static/media/flowdiagram.3430defd.png";